module.exports = __webpack_public_path__ + "media/images/marketing/video_thumbnail1-d736da23034d9503efacf9643b787677adf72453e90e75f7a546ad32b709572b.png";